// extracted by mini-css-extract-plugin
export var legendIndicator = "_ff-1";
export var legendRight = "_ff-0";